var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{attrs:{"role":"main"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[_c('h1',[_vm._v(_vm._s(_vm.$t('text.globals.error'))+"!")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1bdad4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Error.vue
// module id = null
// module chunks = 